import { Injectable } from "@angular/core";
import { FeUtil, API } from "../../../hezky-routes";
import { Observable, take } from "rxjs";

@Injectable({ providedIn: 'root' })
export class NotificationService {
    get unreadCount(): number {
        return this._notificationCount;
    }
    set unreadCount(value: number) {
        this._notificationCount = value;
    }    
    private _notificationCount: number = 0;

    constructor(private readonly feUtil: FeUtil) { }

    getAllNotifications(params?: any): Observable<any> {
        return this.feUtil.httpSvc.get(API.NOTIFICATION.GET_ALL, params);
    }

    markNotificationAsRead(payload: any): Observable<any> {
        return this.feUtil.httpSvc.patch(API.NOTIFICATION.MARK_READ, payload);
    }

    // HELPER METHODS
    /**
     * Fetches all notifications and updates the internal unread notification count.
     * The count is updated only if the API response is successful (status 200).
     */
    updateNotificationCount(count?: number): void {
        if (count) {
            this._notificationCount = count;
            return;
        }
        this.getAllNotifications().subscribe({
            next: ({ status, data }) => {
                if (status !== 200) return;
                this._notificationCount = data?.total_unread;
            }
        })
    }
}